<div tp="Need to Save changes" [tpIsEnabled]="needSave === true">
  <button
    data-cy="repoOptionsMenuButton"
    class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
    [ngClass]="{
      'cursor-default': needSave === true,
      'hover:bg-m200': needSave === false
    }"
    [disabled]="needSave === true"
    #t1="tippy"
    [tp]="templateRepoOptions"
    [tpHideOnEscape]="true"
    tpVariation="menu"
    className="my-menu"
  >
    <m-dots-vertical-icon></m-dots-vertical-icon>
  </button>
</div>

<ng-template #templateRepoOptions>
  <div class="border-s4 bg-m0 w-64 rounded-md border-2 shadow-xl">
    <button
      data-cy="repoOptionsRevertRepoToLastCommitButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      [ngClass]="{
        'text-s400 cursor-default': needSave === true
      }"
      [disabled]="needSave === true"
      (click)="t1.hide(); revertToLastCommit($event)"
      >Revert to Last Commit</button
    >

    <div
      tp="Not available for Session repos"
      [tpIsEnabled]="nav?.repoType === repoTypeSession"
    >
      <button
        data-cy="repoOptionsRevertRepoToRemoteButton"
        class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            needSave === true || nav?.repoType === repoTypeSession
        }"
        [disabled]="needSave === true || nav?.repoType === repoTypeSession"
        (click)="t1.hide(); revertToRemote($event)"
        >Revert to Remote</button
      >
    </div>

    <button
      data-cy="repoOptionsPullFromRemoteButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      [ngClass]="{
        'text-s400 cursor-default':
          needSave === true || repo?.repoStatus === repoStatusNeedCommit
      }"
      [disabled]="
        needSave === true || repo?.repoStatus === repoStatusNeedCommit
      "
      (click)="t1.hide(); pullFromRemote($event)"
      >Pull from Remote</button
    >

    <button
      data-cy="repoOptionsGitFetchButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      [ngClass]="{
        'text-s400 cursor-default': needSave === true
      }"
      [disabled]="needSave === true"
      (click)="t1.hide(); gitFetch($event)"
      >Refresh (git Fetch)</button
    >

    <button
      data-cy="repoOptionsValidateButton"
      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
      [ngClass]="{
        'text-s400 cursor-default': needSave === true
      }"
      [disabled]="needSave === true"
      (click)="t1.hide(); validate($event)"
      >Validate Files</button
    >
  </div>
</ng-template>

<div *ngIf="nav$ | async"></div>
<div *ngIf="file$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="builderLeft$ | async"></div>
<div *ngIf="repo$ | async"></div>
